// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-fix-tab":"FixTab_amazon-sale-fix-tab__d0Jsr"};